import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { getError } from 'utils/appHelpers';
import { ArrowLeftIcon, ArrowLeftLargeIcon, PlusLargeIcon } from 'shared/components/Icons';
import { useTranslation } from 'react-i18next';
import { getPollData, getPollVotesResult } from '../../actions/polls';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import PollBlock from './components/PollBlock';
import Button from 'shared/components/Button';
import CreatePollModal from '../Polls/components/CreatePollModal';

const PollView = ({ match }) => {
  const { t } = useTranslation();
  const [openPollModal, setOpenPollModal] = useState(false);
  const history = useHistory();
  const polls = useSelector(state => state.polls);
  const poll = polls?.find(i => i.id === match?.params.id);
  const alert = useAlert();

  const getPoll = async () => {
    try {
      await getPollData(match?.params.id);
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const goBack = () => {
    history.push('/polls');
  };

  const onSuccessPollCreation = item => {
    history.push(`/poll/${item.id}`);
  };

  const handleChangePoll = isNext => {
    const activePolls = [...polls].filter(i => i.isActive);
    const currentIndex = activePolls.findIndex(i => i.id === match?.params.id);
    const nextIndex = currentIndex + Number(isNext ? 1 : -1);
    const nextPoll = activePolls[nextIndex]
      ? activePolls[nextIndex]
      : isNext
      ? activePolls[0]
      : activePolls[activePolls.length - 1];
    history.push(`/poll/${nextPoll.id}`);
  };

  useEffect(() => {
    getPoll();
  }, []);

  if (!poll) return <SkeletonLoader type='page' count={3} className='my-20' />;

  const activePolls = [...polls].filter(i => i.isActive);
  const votesResult = getPollVotesResult(poll?.votes);

  return (
    <div className='polls-page'>
      <div className='d-flex align-items-center justify-content-between mb-10'>
        <h1 className='d-flex align-items-center mb-3'>
          <button className='btn p-0 mr-5' onClick={goBack}>
            <ArrowLeftLargeIcon />
          </button>
          <span>{poll.title}</span>
        </h1>
        <div className='d-none d-md-flex align-items-center justify-content-start justify-content-md-end'>
          <Button
            className='btn-sm btn-outline-dark d-flex align-items-center px-8 py-2 py-md-4'
            onClick={() => setOpenPollModal(true)}
          >
            <PlusLargeIcon className='mr-5' />
            {t('btn_create_poll')}
          </Button>
        </div>
      </div>
      <div className='mt-10 row'>
        <div className='col-1 align-items-center justify-content-center d-none d-md-flex'>
          <button
            disabled={!activePolls?.length || activePolls?.length < 2}
            className='btn p-0 btn-icon svg-white d-flex align-items-center justify-content-center'
            onClick={handleChangePoll.bind(null, false)}
          >
            <ArrowLeftIcon />
          </button>
        </div>
        <div className='col-12 col-md-10'>
          <PollBlock className='lg-block' poll={poll} hideTitle={true} showAddLikiee={true} isPollView={true} />
          <div className='my-md-27 my-11 row'>
            <div className='col-12 col-md-6'>
              <h2 className='mb-6'>{poll.title}</h2>
              <p className='text-gray-dark'>{poll.description}</p>
            </div>
            <div className='col-12 col-md-6 d-flex align-items-baseline'>
              <div className='pol-stats d-flex py-5 py-md-10 px-8 px-md-9 bg-gray-light rounded-10'>
                <div className='flex-fill pl-16 pr-24 border-right border-dark'>
                  <h2 className='mb-2 mb-md-5 fw-400'>{votesResult.first}%</h2>
                  <p className='text-gray-dark mb-0'>{t('poll_stats_vote_1')}</p>
                </div>
                <div className='flex-fill px-16'>
                  <h2 className='mb-2 mb-md-5 fw-400'>{votesResult.second}%</h2>
                  <p className='text-gray-dark mb-0'>{t('poll_stats_vote_2')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-1 align-items-center justify-content-center d-none d-md-flex'>
          <button
            disabled={!activePolls?.length || activePolls?.length < 2}
            className='btn p-0 btn-icon svg-white rotate-180 d-flex align-items-center justify-content-center'
            onClick={handleChangePoll.bind(null, true)}
          >
            <ArrowLeftIcon />
          </button>
        </div>
      </div>
      {openPollModal && <CreatePollModal onClose={() => setOpenPollModal(false)} onSuccess={onSuccessPollCreation} />}
    </div>
  );
};

export default PollView;
